<!-- ══════════════════════════════════════════════════════════════════════════
     «TEMAS» — solapa de la ficha del comercio.
     RUTA HIJA: la miga, el nombre, la tira del portal y las solapas los pone
     el padre (`comercios-detail`). Aquí sólo lo de esta solapa.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="space-y-6 pt-2">

  <p class="m-0 flex items-center gap-2 text-sm text-muted-foreground" *ngIf="!puedeEditar" role="status">
    <i class="fas fa-eye" aria-hidden="true"></i>Estás viendo en modo de sólo lectura.
  </p>

  <!-- ── Cargando ── -->
  <div *ngIf="cargando" class="tm-trabajo" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-[560px] w-full rounded-xl"></div>
    <div class="kb-skeleton h-[560px] w-full rounded-xl"></div>
  </div>

  <!-- ── No se pudo leer ── -->
  <div class="kb-tira" *ngIf="!cargando && error" role="alert">
    <p class="m-0 text-sm">
      <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
      No se pudo leer el tema de este comercio. <span class="text-muted-foreground">{{ error }}</span>
    </p>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cargar()">
      <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
    </button>
  </div>

  <ng-container *ngIf="!cargando && !error">
    <div class="grid gap-1">
      <h2 class="m-0 text-lg font-semibold tracking-tight">Tema del portal</h2>
      <p class="m-0 max-w-2xl text-sm text-muted-foreground">
        El portal de {{ nombre }} se pinta con el tema que escojas aquí. Lo ven todos sus usuarios al entrar,
        en modo claro y en oscuro. La letra, los tamaños y la disposición no cambian.
      </p>
    </div>

    <div class="tm-trabajo">
      <!-- ─────────────── los controles ─────────────── -->
      <div class="tm-panel">
        <section class="tm-seccion" aria-labelledby="tm-r-tema">
          <div class="tm-rotulo" id="tm-r-tema">Tema <span>· {{ OPCIONES.length + temasGuardados.length }} opciones</span></div>
          <div class="tm-opciones" role="radiogroup" aria-labelledby="tm-r-tema">
            <ng-container *ngFor="let op of OPCIONES">
            <!-- LOS TEMAS GUARDADOS van justo antes de Personalizado (Juan, 2026-09-25: guardar con un
                 nombre y poder eliminarlo). Sirven para todos los comercios. -->
            <ng-container *ngIf="op.valor === 'personalizado'">
              <label class="tm-opcion" *ngFor="let t of temasGuardados" [attr.for]="'tm-g-' + t._id"
                     [class.tm-opcion-activa]="idGuardadoActivo === t._id" [class.tm-opcion-bloqueada]="!puedeEditar">
                <span class="tm-opcion-cuerpo">
                  <span class="tm-opcion-fila">
                    <span class="tm-opcion-tit">{{ t.name }}</span>
                    <span class="tm-muestras" aria-hidden="true">
                      <i [style.background]="t.colores.principal"></i><i [style.background]="t.colores.acento"></i><i [style.background]="t.colores.base"></i>
                    </span>
                  </span>
                  <span class="tm-opcion-desc" *ngIf="porEliminar !== t._id">Guardado en la lista de temas.</span>
                  <span class="tm-confirmar" *ngIf="porEliminar === t._id" role="alert">
                    ¿Eliminar «{{ t.name }}»? Los comercios que ya lo usan no cambian.
                    <span class="tm-confirmar-botones">
                      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="eliminando" (click)="eliminarGuardado($event, t)">
                        <i class="fas fa-trash-alt kb-texto-peligro" aria-hidden="true"></i>Eliminar
                      </button>
                      <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="cancelarEliminar($event)">No</button>
                    </span>
                  </span>
                </span>
                <button type="button" class="tm-eliminar" *ngIf="puedeEditar && porEliminar !== t._id"
                        [attr.aria-label]="'Eliminar el tema ' + t.name" title="Eliminar de la lista" (click)="pedirEliminar($event, t)">
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
                <input class="tm-radio" type="radio" name="tm-tema" [id]="'tm-g-' + t._id"
                       [checked]="idGuardadoActivo === t._id" [disabled]="!puedeEditar" (change)="elegirGuardado(t)">
              </label>
            </ng-container>
            <label class="tm-opcion" [attr.for]="'tm-t-' + op.valor"
                   [class.tm-opcion-activa]="preset === op.valor && !(op.valor === 'personalizado' && idGuardadoActivo)" [class.tm-opcion-bloqueada]="!puedeEditar">
              <span class="tm-opcion-cuerpo">
                <span class="tm-opcion-fila">
                  <span class="tm-opcion-tit">{{ op.titulo }}</span>
                  <span class="tm-muestras" aria-hidden="true">
                    <i *ngFor="let m of (op.valor === 'personalizado' ? [visibles.principal, visibles.acento, visibles.base] : op.muestras)"
                       [style.background]="m"></i>
                  </span>
                </span>
                <span class="tm-opcion-desc">{{ op.desc }}</span>
              </span>
              <input class="tm-radio" type="radio" name="tm-tema" [id]="'tm-t-' + op.valor" [value]="op.valor"
                     [checked]="preset === op.valor && !(op.valor === 'personalizado' && idGuardadoActivo)" [disabled]="!puedeEditar" (change)="elegir(op.valor)">
            </label>
            </ng-container>
          </div>
          <p class="m-0 text-[12.5px] text-muted-foreground" *ngIf="errorLista">{{ errorLista }}</p>
          <!-- GUARDAR EN LA LISTA: un personalizado que todavía no está en la lista. -->
          <form class="tm-guardar-lista" *ngIf="personalizado && !idGuardadoActivo && puedeEditar" (submit)="$event.preventDefault(); guardarEnLista()">
            <span>¿Te gusta cómo quedó? Guárdalo con un nombre y úsalo en cualquier comercio.</span>
            <div class="tm-guardar-fila">
              <input class="kb-input tm-nombre-tema" name="nombreTema" maxlength="40" placeholder="Nombre del tema" aria-label="Nombre del tema"
                     [(ngModel)]="nombreNuevo" [disabled]="guardandoEnLista">
              <button type="submit" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="nombreNuevo.trim().length < 2 || guardandoEnLista">
                <i class="fas fa-bookmark !text-foreground" aria-hidden="true"></i>Guardar en la lista
              </button>
            </div>
          </form>
          <p class="m-0 text-[12.5px]" role="status" *ngIf="resultadoLista"
             [class.text-muted-foreground]="resultadoLista.ok" [class.text-destructive]="!resultadoLista.ok">{{ resultadoLista.texto }}</p>
          <!-- CLONAR: Juan, 2026-09-25 — «yo puedo clonar hacia personalizado cualquiera de los que tengo». -->
          <div class="tm-clonar" *ngIf="!personalizado && puedeEditar">
            <span>¿Quieres cambiarle algo a {{ NOMBRE_PRESET[preset] }}? Cópialo a Personalizado y cambia solo lo que quieras.</span>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="clonar()">
              <i class="fas fa-copy !text-foreground" aria-hidden="true"></i>Copiar a Personalizado
            </button>
          </div>
        </section>

        <!-- EL LOGO DEL COMERCIO — Juan, 2026-09-25: «una sección en el tema para cargar el logo… o el ícono». -->
        <section class="tm-seccion" aria-labelledby="tm-r-logo">
          <div class="tm-rotulo" id="tm-r-logo">Logo del comercio</div>
          <div class="tm-logo-fila">
            <div class="tm-logo-muestra" [class.tm-logo-vacio]="!logo" aria-hidden="true">
              <img *ngIf="logo" [src]="logo" alt="">
              <i *ngIf="!logo" class="fas fa-store"></i>
            </div>
            <div class="tm-logo-texto">
              <span class="tm-nombre">{{ logo ? 'Así se ve en la barra del portal' : 'Sin logo: la barra muestra la casita' }}</span>
              <span class="tm-rol">Mejor el ícono que el logo completo: el cuadro de la barra es chico. Se recorta a 256 px.</span>
              <div class="flex flex-wrap items-center gap-2" *ngIf="puedeEditar">
                <label class="kb-btn kb-btn-outline kb-btn-sm m-0 cursor-pointer">
                  <i class="fas fa-upload !text-foreground" aria-hidden="true"></i>{{ logo ? 'Cambiar imagen' : 'Subir imagen' }}
                  <input type="file" class="sr-only" accept="image/png,image/jpeg,image/webp,image/svg+xml" (change)="subirLogo($event)">
                </label>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="logo" (click)="quitarLogo()">Quitar logo</button>
              </div>
              <div class="tm-toggle" role="group" aria-label="Cómo entra la imagen en el cuadro" *ngIf="puedeEditar && logo">
                <button type="button" [attr.aria-pressed]="modoLogo === 'ajustar'" (click)="ponerModoLogo('ajustar')" [title]="'Entera, con aire alrededor'">Ajustar</button>
                <button type="button" [attr.aria-pressed]="modoLogo === 'llenar'" (click)="ponerModoLogo('llenar')" [title]="'Agrandada hasta cubrir el cuadro'">Llenar el cuadro</button>
              </div>
              <p class="m-0 text-[12.5px] text-destructive" role="alert" *ngIf="errorLogo">{{ errorLogo }}</p>
            </div>
          </div>
        </section>

        <!-- EL INGRESO — Juan, 2026-09-25: tres modelos seleccionables, de shadcn. -->
        <section class="tm-seccion" aria-labelledby="tm-r-ingreso">
          <div class="tm-rotulo" id="tm-r-ingreso">Ingreso <span>· {{ MODELOS.length }} modelos</span></div>
          <div class="tm-opciones" role="radiogroup" aria-labelledby="tm-r-ingreso">
            <label class="tm-opcion tm-modelo" *ngFor="let md of MODELOS" [attr.for]="'tm-l-' + md.valor"
                   [class.tm-opcion-activa]="login === md.valor" [class.tm-opcion-bloqueada]="!puedeEditar">
              <span class="tm-esquema" [ngClass]="'tm-esquema-' + md.valor" aria-hidden="true">
                <i class="e-panel"></i><i class="e-tarjeta"><b></b><b></b><b class="e-boton"></b></i>
              </span>
              <span class="tm-opcion-cuerpo">
                <span class="tm-opcion-fila"><span class="tm-opcion-tit">{{ md.titulo }}</span><code class="tm-bloque">{{ md.bloque }}</code></span>
                <span class="tm-opcion-desc">{{ md.desc }}</span>
              </span>
              <input class="tm-radio" type="radio" name="tm-login" [id]="'tm-l-' + md.valor"
                     [checked]="login === md.valor" [disabled]="!puedeEditar" (change)="elegirModelo(md.valor)">
            </label>
          </div>
        </section>

        <section class="tm-seccion" aria-labelledby="tm-r-colores">
          <div class="tm-rotulo" id="tm-r-colores">Los colores</div>

          <!-- Principal + la rueda de tonos -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Principal</span>
              <span class="tm-rol">Botones, renglón activo del menú y foco.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.principal" title="Escoger el color">
                <input type="color" aria-label="Color principal" [value]="visibles.principal.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('principal', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color principal"
                     [value]="hex.principal" [readonly]="!puedeEditar"
                     (focus)="enfocar('principal')" (blur)="enfocar(null)" (input)="escribirHex('principal', $event)">
              <span class="tm-addon">{{ tonos.principal }}</span>
            </div>
            <div class="tm-rueda-fila">
              <div class="tm-rueda" role="slider" tabindex="0" aria-label="Tono del color principal"
                   aria-valuemin="0" aria-valuemax="359" [attr.aria-valuenow]="tonoValor"
                   [attr.aria-valuetext]="tono === '—' ? 'sin tono' : tonoValor + ' grados'"
                   (pointerdown)="ruedaAbajo($event)" (pointermove)="ruedaMueve($event)" (keydown)="ruedaTecla($event)">
                <div class="tm-anillo" [style.background]="anillo"></div>
                <svg viewBox="0 0 132 132" aria-hidden="true">
                  <path *ngFor="let m of marcas" [attr.d]="m.d" [class]="m.clase" stroke="currentColor" stroke-width="3" stroke-linecap="round" fill="none"></path>
                  <ng-container *ngIf="puntoA">
                    <circle [attr.cx]="puntoA.x" [attr.cy]="puntoA.y" r="6" [attr.fill]="puntoA.color" class="tm-punto-borde" stroke-width="2"></circle>
                  </ng-container>
                  <ng-container *ngIf="puntoP">
                    <circle [attr.cx]="puntoP.x" [attr.cy]="puntoP.y" r="10" [attr.fill]="puntoP.color" class="tm-punto-borde" stroke-width="2.5"></circle>
                  </ng-container>
                </svg>
                <div class="tm-rueda-centro"><small>Tono</small><b>{{ tono }}</b></div>
              </div>
              <div class="tm-rueda-texto">
                <span>Arrastra el punto grande para cambiar el tono. El chico es el acento.</span>
                <span class="tm-leyenda">
                  <span><i class="kb-texto-peligro"></i>error</span>
                  <span><i class="kb-texto-alerta"></i>atención</span>
                  <span><i class="kb-texto-exito"></i>bien</span>
                </span>
                <span>Esas marcas son los colores de estado. El acento que te proponemos las esquiva.</span>
              </div>
            </div>
          </div>

          <!-- Acento -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Acento</span>
              <span class="tm-rol">La marca: el cuadro del comercio en la barra.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.acento" title="Escoger el color">
                <input type="color" aria-label="Color de acento" [value]="visibles.acento.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('acento', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color de acento"
                     [value]="hex.acento" [readonly]="!puedeEditar"
                     (focus)="enfocar('acento')" (blur)="enfocar(null)" (input)="escribirHex('acento', $event)">
              <span class="tm-addon">{{ tonos.acento }}</span>
            </div>
            <ng-container *ngIf="personalizado">
              <div class="tm-propuesta" id="tm-p-acento">Te proponemos</div>
              <div class="tm-chips" role="group" aria-labelledby="tm-p-acento">
                <button type="button" class="tm-chip" *ngFor="let a of acentos; let i = index"
                        [attr.aria-pressed]="!acentoManual && iAcento === i" [disabled]="!puedeEditar" (click)="elegirAcento(i)">
                  <i [style.background]="a.hex"></i>{{ a.nombre }}
                </button>
              </div>
            </ng-container>
          </div>

          <!-- Base -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Base</span>
              <span class="tm-rol">El tinte de fondos, tarjetas y bordes.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.base" title="Escoger el color">
                <input type="color" aria-label="Color base" [value]="visibles.base.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('base', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color base"
                     [value]="hex.base" [readonly]="!puedeEditar"
                     (focus)="enfocar('base')" (blur)="enfocar(null)" (input)="escribirHex('base', $event)">
              <span class="tm-addon">{{ tonos.base }}</span>
            </div>
            <ng-container *ngIf="personalizado">
              <div class="tm-propuesta" id="tm-p-base">Te proponemos</div>
              <div class="tm-chips" role="group" aria-labelledby="tm-p-base">
                <button type="button" class="tm-chip" *ngFor="let b of bases; let i = index" [title]="b.nota"
                        [attr.aria-pressed]="!baseManual && iBase === i" [disabled]="!puedeEditar" (click)="elegirBase(i)">
                  <i [style.background]="b.hex"></i>{{ b.nombre }} <small>{{ b.nota }}</small>
                </button>
              </div>
            </ng-container>
          </div>

          <!-- El fondo — Juan, 2026-09-25: «¿cómo cambio el gris de fondo si no quiero ese gris?» -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Fondo</span>
              <span class="tm-rol">El fondo de las pantallas en modo claro. Las tarjetas siguen blancas. En oscuro va siempre oscuro.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.fondo" title="Escoger el color">
                <input type="color" aria-label="Color de fondo" [value]="visibles.fondo.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('fondo', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color de fondo"
                     [value]="hex.fondo" [readonly]="!puedeEditar"
                     (focus)="enfocar('fondo')" (blur)="enfocar(null)" (input)="escribirHex('fondo', $event)">
              <span class="tm-addon">{{ tonos.fondo }}</span>
            </div>
            <div class="tm-chips" role="group" aria-label="Atajos para el color de fondo">
              <button type="button" class="tm-chip" *ngFor="let o of atajosFondo; let i = index"
                      [attr.aria-pressed]="i === iFondo" [disabled]="!puedeEditar" (click)="ponerFondo(o.hex)">
                <i [style.background]="o.hex"></i>{{ o.nombre }}
              </button>
            </div>
          </div>

          <!-- La barra -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Barra lateral</span>
              <span class="tm-rol">El color de la barra del menú en modo claro. La letra la escoge el sistema. En oscuro va siempre oscura.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.barra" title="Escoger el color">
                <input type="color" aria-label="Color de la barra lateral" [value]="visibles.barra.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('barra', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color de la barra lateral"
                     [value]="hex.barra" [readonly]="!puedeEditar"
                     (focus)="enfocar('barra')" (blur)="enfocar(null)" (input)="escribirHex('barra', $event)">
              <span class="tm-addon">{{ tonos.barra }}</span>
            </div>
            <div class="tm-chips" role="group" aria-label="Atajos para el color de la barra">
              <button type="button" class="tm-chip" *ngFor="let o of atajosBarra; let i = index"
                      [attr.aria-pressed]="i === iBarra" [disabled]="!puedeEditar" (click)="ponerBarra(o.hex)">
                <i [style.background]="o.hex"></i>{{ o.nombre }}
              </button>
            </div>
          </div>
          <!-- El panel del ingreso — Juan, 2026-09-25: «el color de afuera del login siempre está en negro» -->
          <div class="tm-fila">
            <div class="tm-cab">
              <span class="tm-nombre">Panel del ingreso</span>
              <span class="tm-rol">El color de afuera de la pantalla de ingreso. La letra la escoge el sistema.</span>
            </div>
            <div class="tm-grupo-input">
              <label class="tm-muestra-input" [style.background]="visibles.panel" title="Escoger el color">
                <input type="color" aria-label="Color del panel del ingreso" [value]="visibles.panel.toLowerCase()"
                       [disabled]="!puedeEditar" (input)="ponerColor('panel', $any($event.target).value)">
              </label>
              <input class="tm-hex" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Código del color del panel del ingreso"
                     [value]="hex.panel" [readonly]="!puedeEditar"
                     (focus)="enfocar('panel')" (blur)="enfocar(null)" (input)="escribirHex('panel', $event)">
              <span class="tm-addon">{{ tonos.panel }}</span>
            </div>
            <div class="tm-chips" role="group" aria-label="Atajos para el color del panel del ingreso">
              <button type="button" class="tm-chip" *ngFor="let o of atajosPanel; let i = index"
                      [attr.aria-pressed]="i === iPanel" [disabled]="!puedeEditar" (click)="ponerPanel(o.hex)">
                <i [style.background]="o.hex"></i>{{ o.nombre }}
              </button>
            </div>
          </div>
        </section>

        <section class="tm-seccion" aria-labelledby="tm-r-lectura">
          <div class="tm-rotulo" id="tm-r-lectura">Cómo se lee <span>· {{ pruebas.length }} pruebas</span></div>
          <div class="tm-lectura">
            <span class="tm-th">Prueba</span><span class="tm-th">Claro</span><span class="tm-th">Oscuro</span>
            <ng-container *ngFor="let p of pruebas">
              <span class="tm-etq">{{ p.etq }}</span>
              <ng-container *ngTemplateOutlet="celda; context: { $implicit: p.claro }"></ng-container>
              <ng-container *ngTemplateOutlet="celda; context: { $implicit: p.oscuro }"></ng-container>
            </ng-container>
          </div>
          <div class="tm-notas">
            <div class="tm-nota" *ngFor="let n of notas" [class.tm-nota-aviso]="n.aviso">
              <i class="fas" [class.fa-exclamation-triangle]="n.aviso" [class.fa-info-circle]="!n.aviso" aria-hidden="true"></i>
              <span>{{ n.texto }}</span>
            </div>
          </div>
        </section>

        <section class="tm-seccion" *ngIf="puedeEditar">
          <div class="flex flex-wrap items-center gap-2">
            <button type="button" class="kb-btn kb-btn-primary" [disabled]="sinCambios || guardando" (click)="guardar()">
              <i class="fas fa-spinner fa-spin" *ngIf="guardando" aria-hidden="true"></i>Guardar tema de {{ nombre }}
            </button>
            <button type="button" class="kb-btn kb-btn-outline" [disabled]="sinCambios || guardando" (click)="descartar()">Descartar cambios</button>
          </div>
          <p class="m-0 text-[13px]" role="status"
             [class.text-muted-foreground]="!resultado || resultado.ok" [class.text-destructive]="resultado && !resultado.ok">
            <ng-container *ngIf="resultado">{{ resultado.texto }}</ng-container>
            <ng-container *ngIf="!resultado && sinCambios">Es el tema que tiene hoy {{ nombre }}.</ng-container>
            <ng-container *ngIf="!resultado && !sinCambios">Tienes cambios sin guardar. Hoy {{ nombre }} tiene el {{ NOMBRE_PRESET[guardado.preset] }}.</ng-container>
          </p>
        </section>
      </div>

      <!-- ─────────────── el portal ─────────────── -->
      <div class="min-w-0">
        <div class="tm-vista-cab">
          <div>
            <div class="tm-rotulo">Así lo ve el comercio</div>
            <p class="m-0 mt-1 text-[13px] text-muted-foreground">El resumen del administrador, con datos de ejemplo. Arrastra la línea para comparar claro y oscuro.</p>
          </div>
          <div class="tm-toggle" role="group" aria-label="Modo de la vista">
            <button type="button" [attr.aria-pressed]="vista === 'claro'" (click)="ponerVista('claro')">Claro</button>
            <button type="button" [attr.aria-pressed]="vista === 'comparar'" (click)="ponerVista('comparar')">Comparar</button>
            <button type="button" [attr.aria-pressed]="vista === 'oscuro'" (click)="ponerVista('oscuro')">Oscuro</button>
          </div>
        </div>
        <div class="tm-marco" #marco>
          <div class="tm-desliza">
            <div class="tm-capas" #capas [attr.style]="'--corte:' + corte + '%;zoom:' + escala">
              <div [attr.style]="estiloClaro">
                <ng-container *ngTemplateOutlet="portal; context: { $implicit: 'claro' }"></ng-container>
              </div>
              <div class="tm-capa-oscura" [attr.style]="estiloOscuro">
                <ng-container *ngTemplateOutlet="portal; context: { $implicit: 'oscuro' }"></ng-container>
              </div>
              <div class="tm-corte" *ngIf="vista === 'comparar'"
                   (pointerdown)="corteAbajo($event, capas)" (pointermove)="corteMueve($event, capas)">
                <span class="tm-lado tm-lado-izq">Claro</span>
                <span class="tm-lado tm-lado-der">Oscuro</span>
                <div class="tm-perilla" role="slider" tabindex="0" aria-label="Línea entre claro y oscuro"
                     aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="corte | number: '1.0-0'" (keydown)="corteTecla($event)">
                  <i class="fas fa-arrows-alt-h" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tm-no-toca">
          <span>Lo que el tema nunca toca:</span>
          <span>la letra y los tamaños</span>
          <span>la disposición</span>
          <span><i class="kb-texto-exito"></i><i class="kb-texto-alerta"></i><i class="kb-texto-peligro"></i>los colores de estado</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Una celda de «Cómo se lee»: la muestra «Aa» pintada con la letra y el fondo reales, y la cifra. -->
<ng-template #celda let-c>
  <span class="tm-celda">
    <span class="tm-aa" [style.background]="c.bg" [style.color]="c.fg">Aa</span>{{ c.ratio }}
    <i class="fas" [class.fa-check]="c.nivel === 'bien'" [class.fa-exclamation-triangle]="c.nivel === 'justo'" [class.fa-times]="c.nivel === 'mal'"
       [class.kb-texto-exito]="c.nivel === 'bien'" [class.kb-texto-alerta]="c.nivel === 'justo'" [class.kb-texto-peligro]="c.nivel === 'mal'" aria-hidden="true"></i>
  </span>
</ng-template>

<!-- El portal en miniatura: pinta SÓLO con los tokens --pt-* de su capa. -->
<ng-template #portal let-modo>
  <div class="pt" [class.pt-claro]="modo === 'claro'" [class.pt-oscuro]="modo === 'oscuro'"
       [attr.role]="modo === 'claro' ? 'img' : null" [attr.aria-hidden]="modo === 'oscuro' ? 'true' : null"
       [attr.aria-label]="modo === 'claro' ? 'Vista previa del portal del comercio con el tema escogido' : null">
    <aside class="pt-barra">
      <!-- Igual que la barra del portal desde el 2026-09-25: CrediTotal con su CT, una línea, el
           comercio (sin logo: la casita en el color de acento), otra línea y el menú. -->
      <div class="pt-equipo">
        <svg class="pt-ct" viewBox="0 0 512 512" aria-hidden="true">
          <rect class="f" width="512" height="512" rx="112"></rect>
          <g transform="translate(256 256) scale(.74) translate(-245 -284)">
            <path class="ls" d="M237 162 A96 96 0 1 0 242 312" fill="none" stroke-width="54"></path>
            <rect class="lf" x="284" y="146" width="146" height="52"></rect>
            <rect class="lf" x="331" y="146" width="52" height="196"></rect>
            <path class="as" d="M84 316 C140 402 262 432 362 384" fill="none" stroke-width="30" stroke-linecap="round"></path>
            <path class="af" d="M326 350 L420 342 L380 422 Z"></path>
          </g>
        </svg>
        <span><b>CrediTotal</b><small class="pt-tenue-barra">Portal de comercios</small></span>
      </div>
      <i class="pt-linea"></i>
      <div class="pt-equipo">
        <img *ngIf="logo" class="pt-logo" [src]="logo" alt="">
        <span class="pt-marca" *ngIf="!logo"><ng-container *ngTemplateOutlet="icono; context: { $implicit: 'store' }"></ng-container></span>
        <span><b>{{ nombre }}</b><small class="pt-tenue-barra">Administrador</small></span>
      </div>
      <i class="pt-linea"></i>
      <div class="pt-item" *ngFor="let it of MENU; let i = index" [class.pt-on]="i === 0">
        <ng-container *ngTemplateOutlet="icono; context: { $implicit: it[0] }"></ng-container><span>{{ it[1] }}</span>
      </div>
      <div class="pt-usuario">
        <span class="pt-avatar">AP</span><span><b>Andrea Pérez</b><small>usuario de ejemplo</small></span>
        <ng-container *ngTemplateOutlet="icono; context: { $implicit: 'subebaja' }"></ng-container>
      </div>
    </aside>
    <div class="pt-main">
      <header class="pt-cab">
        <span class="pt-tenue"><ng-container *ngTemplateOutlet="icono; context: { $implicit: 'panel' }"></ng-container></span>
        <i class="pt-sep"></i><span class="pt-tenue">{{ nombre }}</span><span class="pt-tenue">›</span><span>Resumen</span>
        <span class="pt-rol">Administrador</span>
        <span class="pt-tenue"><ng-container *ngTemplateOutlet="icono; context: { $implicit: 'luna' }"></ng-container></span>
      </header>
      <div class="pt-cuerpo">
        <div class="pt-tit">
          <div><h3>Resumen</h3><p>Las ventas del comercio hoy y lo que falta por cobrar.</p></div>
          <div class="pt-acciones">
            <span class="pt-btn pt-btn-contorno">Ver órdenes</span>
            <span class="pt-btn"><ng-container *ngTemplateOutlet="icono; context: { $implicit: 'bajar' }"></ng-container>Descargar cierre</span>
          </div>
        </div>
        <div class="pt-tabs"><span class="pt-on">Hoy</span><span>Semana</span><span>Mes</span></div>
        <div class="pt-cifras">
          <div class="pt-cifra"><span class="pt-r">Vendido hoy</span><span class="pt-n">$1.240,00</span><span class="pt-s">18 órdenes</span></div>
          <div class="pt-cifra pt-aviso"><span class="pt-r">Por cobrar</span><span class="pt-n">3</span><span class="pt-s">esperan la firma del cliente</span></div>
          <div class="pt-cifra pt-ok"><span class="pt-r">Cobradas</span><span class="pt-n">14</span><span class="pt-s">$1.085,00</span></div>
          <div class="pt-cifra pt-malo"><span class="pt-r">Anuladas</span><span class="pt-n">1</span><span class="pt-s">$45,00</span></div>
        </div>
        <div class="pt-tarjeta">
          <div class="pt-tarjeta-cab">
            <span class="pt-rotulo">Últimas órdenes · 4</span>
            <span class="pt-busca"><ng-container *ngTemplateOutlet="icono; context: { $implicit: 'buscar' }"></ng-container><span class="pt-cursor"></span>Buscar cliente</span>
          </div>
          <table>
            <thead><tr><th>Orden</th><th>Cliente</th><th class="pt-m">Monto</th><th>Estado</th></tr></thead>
            <tbody>
              <tr *ngFor="let f of FILAS">
                <td class="pt-cod">{{ f[0] }}</td><td>{{ f[1] }}</td><td class="pt-m">{{ f[2] }}</td>
                <td><span class="pt-b" [ngClass]="'pt-b-' + f[3]">{{ f[4] }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #icono let-n>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path *ngFor="let d of ICONOS[n]" [attr.d]="d"></path>
  </svg>
</ng-template>
